/** Lo que devuelve `GET /api/agenda/calendario` (src/agenda/calendario.ts en el núcleo). */

export type CampoDeReserva = {
  clave: string
  etiqueta: string
  tipo: string
  obligatorio?: boolean | null
  ayuda?: null | string
  opciones?: Array<{ valor: string; etiqueta: string }>
  minimo?: null | number
  maximo?: null | number
}

export type ReservaDelCalendario = {
  id: number
  numero: string
  estado: string
  origen: string
  tipo: string
  servicio: { id: number; nombre: string } | null
  recursos: number[]
  nombre: string
  email: null | string
  telefono: null | string
  cantidad: number
  notas: null | string
  datos: null | Record<string, unknown>
  /** El cobro al reservar (seña o total), en céntimos. */
  pago: null | { estado: string; importe: number; moneda: string; pasarela: null | string; devuelto: number }
  desde: string
  hasta: string
  fecha: string
  hora: string
  horaFin: string
  inicioMin: number
  finMin: number
}

export type ServicioDeLaAgenda = { id: number; nombre: string; publicado: boolean; tipo: string; duracionMinutos: number; cantidadMaxima: number; recursos: number[]; campos: CampoDeReserva[] }
export type RecursoDeLaAgenda = { id: number; nombre: string; etiqueta: null | string; tipo: string; capacidad: number }

export type Calendario = {
  zona: string
  pasoMinutos: number
  soloLaSuya: boolean
  dias: Array<{ fecha: string; dia: number }>
  recursos: RecursoDeLaAgenda[]
  abierto: Array<{ recurso: number; fecha: string; desdeMin: number; hastaMin: number }>
  bloqueos: Array<{ id: number; motivo: string; recurso: null | number; desde: string; hasta: string }>
  reservas: ReservaDelCalendario[]
  servicios: ServicioDeLaAgenda[]
}

export type Hueco = { desde: string; hora: string; quedan?: number }

/** Cómo se lee una respuesta guardada: «Sí», la etiqueta de la opción, o el valor tal cual. */
export const valorLegible = (campo: CampoDeReserva | undefined, valor: unknown): string => {
  if (valor === null || valor === undefined || valor === '') return '—'
  if (typeof valor === 'boolean') return valor ? 'Sí' : 'No'
  if (Array.isArray(valor)) return valor.map((v) => valorLegible(campo, v)).join(', ')
  const opcion = campo?.opciones?.find((o) => o.valor === String(valor))
  if (opcion) return opcion.etiqueta
  return typeof valor === 'object' ? JSON.stringify(valor) : String(valor)
}

/** Solo dígitos, para el enlace de WhatsApp; `null` si no parece un teléfono. */
export const numeroDeWhatsApp = (telefono: null | string): null | string => {
  const digitos = (telefono ?? '').replace(/\D/g, '')
  return digitos.length >= 8 && digitos.length <= 15 ? digitos : null
}
